import { InstitutionLogo } from '@mxenabled/mxui'
import { Icon } from '@mxenabled/mx-icons'

import type { AccountSwitchBlockData } from '../../../../core/types/InsightsInstanceSlotData'

import TransferLogoCard from '../../../components/TransferLogoCard'
import { ACCOUNT_CONNECTED_GRADIENT } from '../../../components/celebrationGradients'

import type { BlockProps } from '../../types'

const LOGO_SIZE = 64

// Center-badge glyphs, hoisted to stable module-scope references so they aren't
// re-created each render: `link` for the pending "connect" state and
// `check_circle` for the connected success state (mirrors TransferLogoCard's
// Discovered Accounts default/success states).
const linkBadge = (
  <Icon aria-hidden={true} name="link" size={20} sx={{ color: 'primary.contrastText' }} />
)
const successBadge = (
  <Icon aria-hidden={true} name="check_circle" size={20} sx={{ color: 'common.white' }} />
)

/**
 * Discovered-accounts connect visual: two institution logos on a transfer track.
 * The pending state (`is_connected: false`) shows a link badge on the default
 * slot; the connected state (`is_connected: true`) switches to a success badge
 * with the discovered-accounts gradient and a confetti wash.
 */
const AccountSwitchBlock = ({ payload }: BlockProps<AccountSwitchBlockData>) => {
  const {
    discovered_institution_guid,
    discovered_institution_name,
    held_institution_guid,
    held_institution_name,
    is_connected,
  } = payload.instance_slot_data

  const from = (
    <InstitutionLogo
      alt={discovered_institution_name}
      institutionGuid={discovered_institution_guid}
      size={LOGO_SIZE}
    />
  )
  const to = (
    <InstitutionLogo
      alt={held_institution_name}
      institutionGuid={held_institution_guid}
      size={LOGO_SIZE}
    />
  )

  return (
    <TransferLogoCard
      badgeBgColor={is_connected ? 'success.main' : 'text.secondary'}
      dotColor="text.secondary"
      from={from}
      icon={is_connected ? successBadge : linkBadge}
      to={to}
      {...(is_connected && {
        backgroundImage: ACCOUNT_CONNECTED_GRADIENT,
        bgcolor: 'background.paper',
        showConfetti: true,
      })}
    />
  )
}

export default AccountSwitchBlock
